module.exports = __webpack_public_path__ + "img/bmw-ix-xdrive40.980fe5d8.jpg";